import React, {useState} from 'react'
import { Grid, Icon, makeStyles, Popover, Typography } from '@material-ui/core'
import { blueGrey, grey } from '@material-ui/core/colors'
import cx from 'classnames'

const useStyles = makeStyles(theme => ({
    root:{
        background:'white',
        boxShadow:'0px 0px 5px rgba(0, 0, 0, 0.2)',
        padding:'6px 20px',
        borderRadius:32,
        '&:hover':{
            cursor:'pointer'
        }
    },
    icon:{
        color:blueGrey[500],

    },
    subtitle:{
        paddingLeft:12,
        paddingBottom:4,
        color:blueGrey[400]
    },
    popper:{
        marginTop:8,
        padding:'16px 8px',
        paddingLeft:0,
        borderRadius:32,
        width:200,
        boxSizing:'border-box',
        overflow:'hidden'
    },
    container:{
        maxHeight:250,
        //background:'red',
        overflowX:'hidden',
        overflowY:'auto',
        
    },
    item:{
        fontFamily: theme.typography.fontFamily,
        padding:"12px 16px",
        borderTop:`1px solid ${grey[200]}`,
        '&:hover':{
            cursor:'pointer',
            background:grey[100]
        }
    },
    selected:{
        fontWeight:500
    },
    dot:{
        width:10,
        height:10,
        borderRadius:'50%'
    }
}))

const FilterButton = props => {
    const classes = useStyles()
    const {label, options, selected, onChange} = props

    //console.log(options)

    const [anchorEl, setAnchorEl] = useState(null)

    let selectedItem = options.find(el => el.value === selected)
    //let selectedItem = null

    const onInnerChange = (id) =>{
        setAnchorEl(null)
        onChange(id)
    }


    return(
        <div>
            <Popover classes={{paper:classes.popper}} open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={(e) => setAnchorEl(null)} anchorOrigin={{vertical: 'bottom',horizontal: 'left'}} transformOrigin={{vertical: 'top',horizontal: 'left'}} >
                <div className={classes.container} >
                    {options.map((item,key)=>{
                        return(
                            <div key={key.toString()} className={cx({
                                [classes.item]:true,
                                [classes.selected]: selected === item.value
                            })} onClick={() => onInnerChange(item.value)}>
                                <Typography variant='body2'>{item.label}</Typography>
                            </div>
                        )
                    })}
                </div>
            </Popover>
                <Typography variant='subtitle2' className={classes.subtitle}>{label}</Typography>
            <div className={classes.root} onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Grid container alignItems='center' spacing={1} wrap='nowrap'>
                    <Grid item><Typography variant='body2'>{selectedItem ? selectedItem.label : null}</Typography></Grid>    
                    <Grid item>
                        <Icon className={classes.icon} fontSize='default'>keyboard_arrow_down</Icon>
                    </Grid>
                </Grid>
            </div>
        </div>
        
    )
}

export default FilterButton